<template>
  <div class="admin-view" ref="iframeHolder">
    <!--  Loading indicator to be shown while the iframe is being created  -->
    <v-progress-circular v-if="adminUrl" indeterminate color="primary" class="admin-view__loader" />

    <!--  Error message only meant for development, should not be visible in production  -->
    <div v-else class="admin-view__loader">BAD ADMIN URL</div>

    <!--  <** iframe will be appended here **>  -->
  </div>
</template>

<script>
import { getAdminUrl } from '../../helpers/url';

export default {
  props: {
    adminEndpoint: {
      type: String,
      required: true,
    },
  },

  computed: {
    /**
     * Computes the admin url based on the provided endpoint.
     * Automatically adds the `?readonly=1` query param to display
     * the readonly mode optimized for viewing in an iframe.
     * @returns { string | null }
     */
    adminUrl() {
      if (!this.adminEndpoint) return null;

      const url = new URL(`${getAdminUrl()}${this.adminEndpoint}`);
      url.searchParams.append('readonly', '1');
      return url.href;
    },
  },

  mounted() {
    if (!this.adminUrl) return;

    // Construct the iframe & append it to the DOM
    const iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.zIndex = '1';
    iframe.loading = 'lazy';

    // Log in the user with the refresh token from this app
    // in case they are not already logged in to admin
    iframe.onload = () => {
      // get the refresh token from this app
      const refresh_token = localStorage.getItem(process.env.VUE_APP_JWT_REFRESH);
      if (!refresh_token) {
        console.error('The refresh token for this app is not present. Cannot automatically log in to admin.');
        return;
      }

      // send the refresh token from this app to admin
      iframe.contentWindow.postMessage({ refresh_token: refresh_token }, process.env.VUE_APP_API_URL);
    };

    iframe.src = this.adminUrl;
    this.$refs.iframeHolder.appendChild(iframe);
  },
};
</script>

<style lang="scss" scoped>
.admin-view {
  position: relative;
  display: flex;

  flex-grow: 1;
  isolation: isolate;
}

.admin-view__loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.admin-view__iframe {
  width: 100%;
}
</style>
